export default __webpack_public_path__ + "static/media/no3.41ae578b.png";